"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useBookingCalendar = require("./useBookingCalendar");
Object.keys(_useBookingCalendar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useBookingCalendar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useBookingCalendar[key];
    }
  });
});